(() => {
  const isCartPage = () => window.location.pathname === "/cart";

  async function addToCart(variantId, qty = 1) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  // --- Patch fetch: whenever Dawn updates cart via AJAX on /cart, reload so Liquid upsell recalculates ---
  (function patchFetchForCartChanges() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        if (!isCartPage()) return res;

        const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        const isCartMutation =
          url.includes("/cart/change") ||
          url.includes("/cart/update") ||
          url.includes("/cart/clear") ||
          url.includes("/cart/change.js") ||
          url.includes("/cart/update.js") ||
          url.includes("/cart/clear.js");

        if (isCartMutation && res.ok) {
          // Let Dawn finish DOM update first, then reload to refresh recommendations
          setTimeout(() => window.location.reload(), 50);
        }
      } catch (e) {
        // no-op: never block fetch
      }

      return res;
    };
  })();

  // --- Upsell Add button ---
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-upsell-add]");
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = "Adding…";

    try {
      await addToCart(variantId, 1);

      // Cart page: reload so free-ship & recommendations always correct
      if (isCartPage()) {
        window.location.reload();
        return;
      }

      // If you later use this in drawer, you can add drawer-refresh logic here.
      btn.textContent = "Added";
    } catch (err) {
      console.error(err);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
})();